/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function () {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//aタグ スムーススクロール
$(function () {
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({ scrollTop: position }, speed, "swing");
    return false;
  });
});

//フェード
$(function () {
  var fade = $('.u-fade, .u-fadeB, .js-fadeAni');

  fade.each(function (index, el) {
    var t = $(this);

    setTimeout(function () {
      $(window).on('resize scroll', function (event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if (h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if (sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if ($(window).width() <= 767 && t.attr('data-fade-delay-sp')) {
        d = t.attr('data-fade-delay-sp');
      }
      if (d) {
        pointD = d;
      }

      if (pointH < pointSc) {
        setTimeout(function () {
          t.addClass('is-fade');
          if (t.is('.home-grade__imgImg')) {
            requestAnimationFrame(function () {
              t.find('span').css({
                transition: 'clip-path 1.5s ease',
                clipPath: 'inset(0 0 0 0)'
              });
            });
          }
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if (nextStr) {
        var nextArr = nextStr.split(' ');
        if (nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if (nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if (nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if (nextDelay) {
                step = delay;
              }
              if (nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function (index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function () {
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

//fixバナー のスライダー
$(function () {
  $('.home-fixbnr__slider').each(function () {
    const $slider = $(this);
    $slider.slick({
      autoplay: true,
      autoplaySpeed: 10000,
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//fixバナー を表示
$(function () {
  var $fixbnr = $('.home-fixbnr');
  var $fixbnrShow = $('.js-fixbnrShow');
  if (!$fixbnr.length || !$fixbnrShow.length) return;

  function toggleFixbnr() {
    if ($(window).scrollTop() + $(window).height() > $fixbnrShow.offset().top) {
      $fixbnr.addClass('is-show');
    } else {
      $fixbnr.removeClass('is-show');
    }
  }

  $(window).on('scroll resize', toggleFixbnr);
  toggleFixbnr();
  setInterval(toggleFixbnr, 100);
});

//fixバナー を閉じる
$(function () {
  $('.home-fixbnr__close').on('click', function (event) {
    event.preventDefault();
    $('.home-fixbnr').addClass('is-hide');
  });
});

//fixバナー を開く
$(function () {
  $('.home-fixbnr__ttlSP').on('click', function () {
      $('.home-fixbnr').toggleClass('is-on');
  });
});



//5つの真価 のループアニメ
$(function () {
  var $fig = $('.home-worth__fig');
  if (!$fig.length) return;

  var animationTimer;
  var animationNumber = 1;

  function startAnimation() {
    clearInterval(animationTimer);
    animationNumber = 1;
    $fig.attr('data-ani', animationNumber);
    animationTimer = setInterval(function () {
      animationNumber = animationNumber % 5 + 1;
      $fig.attr('data-ani', animationNumber);
    }, 3000);
  }

  startAnimation();

  $('.home-worth__figLinks button').on('mouseenter focus', function () {
    clearInterval(animationTimer);
    var buttonNumber = $(this).index() + 1;
    $fig.attr('data-ani', '');
    $('.home-worth__fig').attr('data-over', buttonNumber);
  }).on('mouseleave', function () {
    clearInterval(animationTimer);
    $('.home-worth__fig').attr('data-over', '');
    animationTimer = setTimeout(startAnimation, 2000);
  });
});

//5つの真価 のモーダル
$(function () {
  var $modalSlider = $('.home-worth__modalSlider');
  if (!$modalSlider.length) return;

  var selectedModalSlide;
  $(document).on('click', 'button[data-remodal-slide]', function () {
    selectedModalSlide = $(this).attr('data-remodal-slide');
  });
  
  let $slider;
  $modalSlider.each(function () {
    $slider = $(this);
    $slider.on('beforeChange', function (...args) {
      const nextSlide = args[3];
      $slider.attr('data-cr', nextSlide + 1);
    });
    $slider.slick({
      fade: true,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
    $slider.attr('data-cr', $slider.slick('slickCurrentSlide') + 1);
  });

  $('.home-worth__modalPrev').on('click', function (event) {
    event.preventDefault();
    $(this).closest('.remodal').find('.home-worth__modalSlider.slick-initialized').slick('slickPrev');
  });

  $('.home-worth__modalNext').on('click', function (event) {
    event.preventDefault();
    $(this).closest('.remodal').find('.home-worth__modalSlider.slick-initialized').slick('slickNext');
  });

  $(document).on('opening', '.remodal', function (event) {
    setTimeout(function(){
      if(selectedModalSlide) {
        $slider.slick('slickGoTo', Number(selectedModalSlide - 1), true);
      }
    }, 10);
    $slider.slick('setPosition');
  });
});

//ナンバーグレード の画像の動き
$(function () {
  var animationFrame = null;
  var positions = new WeakMap();

  function updateScImgHeights() {
    if (animationFrame !== null) return;

    function update() {
      var moving = false;
      var viewportHeight = window.innerHeight;

      $('.js-scImg').each(function () {
        var scImg = this;
        var rect = scImg.getBoundingClientRect();
        var containerHeight = rect.height;
        var position = positions.has(scImg) ? positions.get(scImg) : 0;
        var baseTop = rect.top - position;
        var progress = Math.max(0, Math.min(1.5,
          (viewportHeight - baseTop) / (viewportHeight + containerHeight)
        ));
        var target = progress * containerHeight * 0.4;
        var difference = target - position;

        // console.log(progress);
        
        if (Math.abs(difference) > 0.001) {
          var nextPosition = position + Math.sign(difference) * Math.abs(difference) * 0.5;

          position = nextPosition;
          moving = true;
        } else {
          position = target;
        }
        positions.set(scImg, position);
        scImg.style.transform = 'translate3d(0, ' + position + 'px, 0)';
      });

      if (moving) {
        animationFrame = requestAnimationFrame(update);
      } else {
        animationFrame = null;
      }
    }

    animationFrame = requestAnimationFrame(update);
  }

  $(window).on('scroll resize', updateScImgHeights);
  updateScImgHeights();
});

//各グレードの条件 の開閉
$(function () {
  $('.home-terms h2 button').on('click', function () {
    var $button = $(this);
    $button.toggleClass('is-on');
    $button.closest('.home-terms').find('.home-terms__con').first().stop(true, true).slideToggle(function () {
      window.ScrollTrigger.refresh();
    });
  });
});

//SPで左へスワイプをフェードアウト
$(function () {
  $('.home-terms__map').on('scroll', function () {
    var $swipe = $('.home-terms__mapSwipe');
    if ($swipe.length && $swipe.css('display') !== 'none') {
      $swipe.stop(true, true).fadeOut();
      $('.home-terms__map').off('scroll');
    }
  });
});

//home-links のSP用スライダー
$(function () {
  $('.home-links__itemsSP').each(function () {
    const $container = $(this);
    const $slider = $container.find('ul');

    $slider.slick({
      autoplay: false,
      autoplaySpeed: 5000,
      speed: 600,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: true,
      variableWidth: true,
      swipe: true,
      touchMove: true,
      swipeToSlide: true,
      infinite: true,
    });

    // Androidで横方向のタッチ操作をブラウザに奪われないようにする
    $slider.find('.slick-list').css('touch-action', 'pan-y');

    $container.closest('.home-links').find('.home-links__next').on('click', function (event) {
      event.preventDefault();
      $slider.slick('slickNext');
    });

    const playSlider = function () {
      if ($container.hasClass('is-fade')) {
        $slider.slick('slickPlay');
      }
    };
    new MutationObserver(playSlider).observe($container[0], {
      attributes: true,
      attributeFilter: ['class']
    });
    playSlider();
  });
});